module.exports = __webpack_public_path__ + "static/media/Danville_Inside.10b98b51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/restaurant/Danville_Inside.jpg
// module id = ./src/app/images/restaurant/Danville_Inside.jpg
// module chunks = 0